<template>
    <div class="container">
        <b-table
                v-if="data && data.length > 0 && data.length <= 1000"
                :narrowed="true"
                :striped="true"
                :data="data"
        >
            <template slot-scope="props">
                <b-table-column numeric label="#" field="num">{{props.row.num}}</b-table-column>
                <b-table-column label="Event time" field="time" centered>{{props.row.time}}</b-table-column>
                <b-table-column label="Title" field="title">
                    <router-link :to="{path: '/objects/' + props.row.object_id}">
                        {{props.row.title}}
                    </router-link>
                </b-table-column>
                <b-table-column label="Value" field="value" numeric>{{props.row.translatedValue}}</b-table-column>
            </template>
        </b-table>
        <div v-else>
            <p v-if="data.length > 1000">Too many results.</p>
            <p v-else style="font-style: italic;">No events.</p>
        </div>
    </div>
</template>

<script>
  import BTable from "buefy/src/components/table/Table";
  import BTableColumn from "buefy/src/components/table/TableColumn";

  export default {
    components: {
      BTableColumn,
      BTable},
    name: "events-log-list",
    props: ['data'],
    computed: {
      list() {
        if (!this.data) {
          return [];
        }

        let num = 0;
        return this.data.map(item => {
          num++;
          return {
            ...item,
            num
          };
        });
      }
    }
  }
</script>

<style scoped>
    .container {
        margin-top: 1.5rem;
    }
</style>